"use client";

import { c as _c } from "react/compiler-runtime";
import WaveGroupManageIdentitiesModal, { WaveGroupManageIdentitiesConfirmEvent, WaveGroupManageIdentitiesMode } from "../../WaveGroupManageIdentitiesModal";
import { WaveGroupIdentitiesModal } from "../hooks/useWaveGroupEditButtonsController";
interface WaveGroupManageIdentitiesModalsProps {
  readonly activeModal: WaveGroupIdentitiesModal | null;
  readonly onClose: () => void;
  readonly onConfirm: (event: WaveGroupManageIdentitiesConfirmEvent) => void;
}
export default function WaveGroupManageIdentitiesModals(t0) {
  const $ = _c(4);
  const {
    activeModal,
    onClose,
    onConfirm
  } = t0;
  if (activeModal === null) {
    return null;
  }
  const modalMode = activeModal === WaveGroupIdentitiesModal.INCLUDE ? WaveGroupManageIdentitiesMode.INCLUDE : WaveGroupManageIdentitiesMode.EXCLUDE;
  let t1;
  if ($[0] !== modalMode || $[1] !== onClose || $[2] !== onConfirm) {
    t1 = <WaveGroupManageIdentitiesModal mode={modalMode} onClose={onClose} onConfirm={onConfirm} />;
    $[0] = modalMode;
    $[1] = onClose;
    $[2] = onConfirm;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}